<template>
  <ButtonComponent class="textCenter w100 mb-10" mod="gradient-bg" @click="addEvent"
    >Создать мероприятие</ButtonComponent
  >
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';

  export default {
    name: 'Widget18',
    components: {
      ButtonComponent,
    },
    props: {
      countryId: {
        type: Number,
        default: null,
      },
    },
    methods: {
      addEvent() {
        this.$router.push({ name: 'EventCardAdd', query: { countryId: this.countryId } });
      },
    },
    data() {
      return {};
    },
    created() {},
  };
</script>

<style lang="scss" scoped></style>
